"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Link = _interopRequireDefault(require("@concur/nui-widgets/lib/Link/Link"));
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/ReadMore.css") : void 0;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ReadMore = function ReadMore(_ref) {
  var text = _ref.text,
    isExpanded = _ref.isExpanded,
    expand = _ref.expand;
  var clickHandler = function clickHandler(e) {
    e.preventDefault();
    expand();
  };
  var renderExpandLink = function renderExpandLink() {
    return /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "#",
      onClick: clickHandler,
      id: "ac-read-more-link",
      target: "_blank",
      rel: "noopener noreferrer"
    }, isExpanded ? /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "ReadLess"
    }) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "ReadMore"
    }));
  };
  var lines = text && text.split(/\r\n|\r|\n/g).length;
  var renderButton = function renderButton() {
    if (text && (text.length > 293 || lines > 3)) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ac-read-more ".concat(isExpanded ? 'ac-read-more-expanded' : '')
      }, renderExpandLink());
    }
    return null;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ac-read-more-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ac-read-more-text ".concat(isExpanded ? 'ac-read-more-text-expanded' : '')
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), renderButton()));
};
ReadMore.propTypes = {
  text: _propTypes.default.string.isRequired,
  isExpanded: _propTypes.default.bool.isRequired,
  expand: _propTypes.default.func.isRequired
};
var _default = exports.default = ReadMore;